import { Controller } from 'react-hook-form'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useMediaQuery } from '@material-ui/core'

const myStyle = {
  marginTop: 1,
  marginBottom: 1,
  color: '#143A5F',
  paddingBottom: '5px',
}

export const InputFilePicker = ({ name, control }) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ...field } }) => {
        return (
          <>
            <Box
              sx={{
                marginBottom: 3,
                display: 'flex',
                flexDirection: isDesktop ? 'column' : 'center',
                justifyContent: isDesktop ? null : 'space-between',
                alignItems: isDesktop ? 'flex-start' : 'center',
              }}
            >
              <input
                accept="application/pdf, image/jpeg, image/png"
                {...field}
                type="file"
                multiple
                id="select-file"
                style={{ display: 'none' }}
                onChange={(e) => onChange(e.target.files)}
              />
              <label htmlFor="select-file">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  sx={{ width: '200px' }}
                >
                  Ajouter des fichiers
                </Button>
              </label>
              {value && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 2,
                  }}
                >
                  {[...value].map((file) => (
                    <p key={file.name} style={myStyle}>
                      {file.name}
                    </p>
                  ))}
                </Box>
              )}
            </Box>
          </>
        )
      }}
    />
  )
}
